import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';


  
function BarChart({ data, title}) {

    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend
      );

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top' ,
            },
            title: {
                display: true,
                text: title,
            },
        },
        scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true
            }
        }
        
    };


    const BarData = {
        labels: data[0].data.map((d) => new Date(d.xLabel).getFullYear()),
        datasets: data.map((d) => {
            return {
                label: d.label,
                data: d.data.map((elm) => elm.value),
                backgroundColor: d.backgroundColor,
            };
        }),
    }



    return (
        <Bar options={options} data={BarData} />
    );
}

export default BarChart;
